module.exports = {
  "id": "f9ce1ee5-7a1a-40a4-a45a-4e381f9d1443",
  "gtmIds": [
    "GTM-M9PR42HQ",
    "GTM-T2TNT6",
    "GTM-KKS578WK"
  ],
  "hasInAppVersion": false,
  "group": "moreys",
  "language": "en-US",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "languages": [
    "en-US"
  ],
  "website": "https://www.joesfishco.com",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}